{
  "eyebrow": "Потвърдете плана",
  "title": "Прегледайте и конфигурирайте.",
  "sub": "Можете да промените цикъла на фактуриране или плана в рамките на своята продуктова линия по всяко време от админ панела. Преминаването между Time и Project се урежда с нашия екип.",
  "yourPlan": "Вашият план",
  "changePlan": "Промени плана",
  "billing": "Цикъл на фактуриране",
  "billingMonthLabel": "Плащане месечно",
  "billingMonthDesc": "Гъвкаво. Отказ по всяко време.",
  "billingYearLabel": "Плащане годишно",
  "billingYearDesc": "15% отстъпка. Фактурира се веднъж годишно.",
  "addons": "Добавки",
  "addon": {
    "ssec": "Социална осигуровка (check-in/out@work)",
    "ssecDesc": "Само Белгия — автоматична декларация Dimona.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "GPS в реално време за служебни автомобили. +4,80 €/превозно средство/месец.",
    "vehicles": "Превозни средства"
  },
  "users": {
    "title": "От колко потребители се нуждаете?",
    "help": "Всеки, който използва Done-it, се брои за един потребител, включително администраторите и служителите.",
    "active": "потребители"
  },
  "estimate": "Прогнозна месечна цена",
  "estimateNote": "Без ДДС. Плащате за броя потребители, зададен тук, и можете да го промените по-късно.",
  "estimateUnavailable": "Каталогът с цени е недостъпен. Опитайте отново, за да заредите най-новите цени."
}
